import { ReactElement } from 'react';
import { isFilterValuePresent } from '@helper/utils';
import { NavLink } from 'react-router-dom';
import { RightTabCount } from '@components/common/count/RightTabCount';
import { ISiteSummerySSFilterTagProps } from '.';
import { SSSiteSummaryFilterObject, useSsSiteSummaryListingStore } from '@store/ssSiteSummaryFilterStore';

export const SsSiteSummaryFilterTag = (props: ISiteSummerySSFilterTagProps): ReactElement => {
	const { count } = props;
	const { updateFilter, resetSiteSummaryFilter, allSSSiteSummaryFilter } = useSsSiteSummaryListingStore();
	const renderFilterValue = (key: string, value: keyof SSSiteSummaryFilterObject): string | null => {
		if (key === 'ss_list') {
			return null;
		}
		return String(value);
	};
	const handleCross = (
		e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
		key: string,
		filterData: SSSiteSummaryFilterObject
	): void => {
		e.preventDefault();
		let defaultValue;
		updateFilter({
			...filterData,
			[key]: defaultValue,
		});
	};

	if (!allSSSiteSummaryFilter || !Object.values(allSSSiteSummaryFilter).some(isFilterValuePresent)) return <></>;

	return (
		<div className="filter-tags">
			<ul className="tag-list">
				{Object.entries(allSSSiteSummaryFilter).map(([key, value]) => {
					if (isFilterValuePresent(value) && renderFilterValue(key, value)) {
						return (
							<li key={key}>
								{`${renderFilterValue(key, value)}`}
								<NavLink
									to="#"
									aria-label="disable tag"
									onClick={(e) => {
										handleCross(e, key, allSSSiteSummaryFilter);
									}}
								>
									<span className="icon-cross"></span>
								</NavLink>
							</li>
						);
					}
				})}
				{Object.values(allSSSiteSummaryFilter).some(isFilterValuePresent) && (
					<a href="/" aria-label="Clear All" className="clear-all-btn" onClick={resetSiteSummaryFilter}>
						Clear All
					</a>
				)}
			</ul>
			<RightTabCount count={count} />
		</div>
	);
};
